// extracted by mini-css-extract-plugin
export default {"homepageContainer":"HomePage_homepageContainer__+k2lH","mainContent":"HomePage_mainContent__YKk1d"};